/** 充值金额最低值 */
export const MIN_AMOUNT = 200

/** 下载推送数量最小值 */
export const MIN_DOWNLOAD_PUSH_COUNT = 0
/** 下载推送数量购买步长 */
export const DOWNLOAD_PUSH_COUNT_STEP = 1

/** 存储空间 */
export const STORAGE = 200

/** 支付成功后跳转的PT页面 */
export const RETURN_URL =
  window.location.origin + '/#/home/index?order_id={order_id}&from=payment'
